<template>
  <app-layout :title="``">
    <template #header>
      <div class="flex w-full justify-between items-center">
        <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none">
          Media viewer
        </h2>
        <div class="flex gap-x-[5px] md:gap-x-[40px] justify-between"></div>
      </div>
    </template>

    <div class="w-full">
      <MediaViewer></MediaViewer>
    </div>

  </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import MediaViewer from '@/Components/Media/MediaViewer.vue';

defineProps({
  modelList: Object,
  sortItems: Object,
  sortItemsURL: String,
  prefixRoute: String,
  usefulLinks: Object,
});
</script>
